/* eslint-disable array-callback-return */
import _ from "lodash";

const getChildGroupOptionConfig = (groupsChildren, groupSelect, groupsList, machines = {}, isFilter = false) => {
  const machineOptions = [];
  if (!_.isEmpty(machines)) {
    machines.map((machine, i) => {
      const opts = {value: machine.id, label: machine.name, status: machine.status}
      machineOptions.push(opts);
    });
  }
  if (_.isEmpty(groupsList)) {
    return {1: [], 2: [], 3: [], 4: [], 5: [], machines: machineOptions};
  }

  let initOptions = [{value: "", label: "[ALL]"}];
  let result = {
    1: [...initOptions, ...groupsList[1]],
    2: initOptions,
    3: initOptions,
    4: initOptions,
    5: initOptions,
    machines: machineOptions
  };
  if (!groupSelect || groupSelect[1] === 0 || groupSelect[1] === null) {
    return result;
  }

  const getChildren = (level) => {
    const getListOptions = (options) => {
      const result = {};
      options.forEach(item => {
        if (!('status' in item) || item.status !== false) {
          const { value, label } = item;
          if (result[label]) {
            if (Array.isArray(value)) {
              result[label].value = [...result[label].value, value];
            } else {
              result[label].value.push(value);
            }
          } else {
            result[label] = {value: Array.isArray(value) ? value : [value], label};
          }
        }
      });
      return Object.values(result);
    }
    if (isFilter) {
      let showAllOption = true;
      for (let i = 1; i < level; i++) {
        if (groupSelect[i] !== undefined && groupSelect[i] !== "") {
          showAllOption = false;
        }
      }
      if (showAllOption) {
        return getListOptions(groupsList[level]);
      }
    }

    let parentLevel = level - 1;
    while(groupSelect[parentLevel] === 0 || groupSelect[1] === null) {
      parentLevel--;
    }

    let children = [];
    let parents = [groupSelect[parentLevel]];
    while (parentLevel < level) {
      children = [];
      for (let i = 0; i < parents.length; i++) {
        let parentIds = parents[i];
        if (Array.isArray(parentIds)) {
          // eslint-disable-next-line no-loop-func
          parentIds.map((parentId) => {
            children = getListOptions([...children, ...(groupsChildren[parentId] ?? [])])
          });
        } else {
          let childrenGroups = [];
          if (groupsChildren[parentIds] !== undefined) {
            childrenGroups = groupsChildren[parentIds].filter(obj => obj.status === true || obj.value === groupSelect[level]);
          }
          children = [...children, ...childrenGroups]
        }
      }
      parentLevel++;
      parents = children.map(v => v.id);
    }
    return children;
  }

  for (let i = 2; i <= 5; i++) {
    let levelSelect = getChildren(i);
    result[i] = [...initOptions, ...levelSelect];
  }
  if (!_.isEmpty(machines)) {
    const machineOption = getMachineOptionForGroup(machines, groupSelect, isFilter);
    result['machines'] = [...initOptions, ...machineOption];
  }
  return result;
}

const getSelectedById = (options, value, labelProp) => {
  if (!options) {
    return null;
  }
  let option = options.find(o => {return String(o.id) === String(value)});
  if (option) {
    return {value: option.id, label: option[labelProp]}
  }
  return null;
}

// Function help to check has error of input
const hasErrorInput = (errors, inputName) => {
  if (_.has(errors, inputName)) {
    return true;
  }
  return false;
};

const hasErrors = (fieldName, errors) => {
  if (errors === undefined || errors.length === 0) {
    return false;
  }
  if (!Array.isArray(fieldName)) {
    if (_.has(errors, fieldName)) {
      return true;
    }
    return false;
  }
  let result = false;
  fieldName.map((name, idx) => {
    if (hasErrorInput(errors, name) === true) {
      result = true
    }
  });
  return result;
}

// get select label from options for select-input
const getSelectLabel = (options, value) => {
  if (!options) {
    return null;
  }
  let option = options.find(o => _.isEqual(o.value, value));
  if (option) {
    return option.label;
  }
  return null;
}


// get selected option from options for select-input
const getSelectedOption = (options, value, defaultOption) => {
  if (!value || !options) return defaultOption;
  if (Array.isArray(value)) {
    const groupSelected = [...value].sort();
    value = groupSelected[0];
  }
  let option = options.find(opt => {
    if (Array.isArray(opt.value)) {
      const groupIds = [...opt.value].sort();
      return groupIds.includes(value);
    }
    return opt.value === value;
  });
  if (option) {
    return {value: value, label: option.label};
  }
  return defaultOption;
}

// function help get machine option with group-selected
const getMachineOptionForGroup = (machines, groupSelect, isFilter) => {
  const results = [];
  if (!_.isEmpty(machines)) {
    let status = [1];
    if (isFilter) {
      status.push(0);
    }
    let machineOptions = machines.filter((machine) => {
      let emptySelect;
      if (isFilter) {
        emptySelect = Object.values(groupSelect).every((groupIds) => {
          if (Array.isArray(groupIds)) {
            return groupIds.length === 0;
          }
          return (groupIds === undefined || groupIds === null || groupIds === "");
        });
      } else {
        emptySelect = Object.values(groupSelect).every((value) => (value === undefined || value === null || value === ""));
      }
      if (emptySelect) {
        return status.includes(machine.status);
      }
      return Object.keys(groupSelect)
        .filter((key) => key !== 'machine' && groupSelect[key] != null && groupSelect[key] !== '')
        .every((group) => {
          return (
            machine.group_relation[`group_${group}_id`] &&
            machine.group_relation[`group_${group}_id`] === parseInt(groupSelect[group])
          );
        });
    });

    if (!_.isEmpty(machineOptions)) {
      machineOptions.map((machine, i) => {
        if (status.includes(machine.status) || machine.id === groupSelect?.machine) {
          const opts = {value: machine.id, label: machine.name};
          results.push(opts);
        }
      });
    }
  }
  return results;
}

const getGroupAndMachines = (data) => {
  let groupAndChildrenOptions = [];
  let groupListOptions = {1: [], 2: [], 3: [], 4: [], 5: []};

  if (!_.isEmpty(data.group_list)) {
    Object.entries(data.group_list).forEach((group) => {
      groupListOptions[group[0]] = group[1].map((v) => {
        return {value: v.id, label: v.name, status: v.status}
      });
    });
  }

  if (!_.isEmpty(data.group_and_children)) {
    Object.entries(data.group_and_children).forEach((group) => {
      groupAndChildrenOptions[group[0]] = group[1].map((v) => {
        return {value: v.id, label: v.name, status: v.status}
      });
    });
  };

  return {groupListOptions, groupAndChildrenOptions};
}

export {
  getChildGroupOptionConfig,
  getSelectedById,
  getSelectLabel,
  getSelectedOption,
  getGroupAndMachines,
  hasErrors
}